// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface RenderableHtmlMetadata {
  hasMath: boolean;
  hasCodeBlock: boolean;
  isPlainText: boolean;
  hasAssetBlock: boolean;
}

export interface RenderableHtmlWithMetadata {
  renderableHtml: string;
  metadata: RenderableHtmlMetadata;
}

export interface CmlContentType {
  dtdId: string;
  value: string;
  renderableHtmlWithMetadata?: RenderableHtmlWithMetadata | null;
}

export interface CmlContentCml {
  typeName: 'cml';
  definition: CmlContentType;
}

export type CmlContent = CmlContentCml;

export type CmlContentTypeName = 'cml';

export interface NoticeData {
  title: CmlContent;
  notice: CmlContent;
  acceptButton: string;
}

export interface EnterpriseNoticesV1 {
  id: string;
  wrapped: string;
  enterpriseNotices: Record<string, NoticeData>;
  thirdPartyOrganizationId: string;
}

export interface EnterpriseNotice {
  enterpriseNotices: Record<string, NoticeData>;
  thirdPartyOrganizationId: string;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseNoticesV1Connection {
  elements: Array<EnterpriseNoticesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseNoticesV1ByOrganizationIdQuery {
  EnterpriseNoticesV1: {
    byOrganizationId: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1ByOrganizationIdQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseNoticesV1DeleteQuery {
  EnterpriseNoticesV1: {
    delete: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseNoticesV1GetQuery {
  EnterpriseNoticesV1: {
    get: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseNoticesV1GetAllQuery {
  EnterpriseNoticesV1: {
    getAll: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1GetAllQueryVariables {
  includes?: string | null;
}

export interface EnterpriseNoticesV1GetLatestQuery {
  EnterpriseNoticesV1: {
    getLatest: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1GetLatestQueryVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseNoticesV1CreateMutation {
  EnterpriseNoticesV1: {
    create: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1CreateMutationVariables {
  input: EnterpriseNotice;
  includes?: string | null;
}

export interface EnterpriseNoticesV1EnableEnterpriseNoticeForOrganizationMutation {
  EnterpriseNoticesV1: {
    enableEnterpriseNoticeForOrganization: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1EnableEnterpriseNoticeForOrganizationMutationVariables {
  input: EnterpriseNotice;
  includes?: string | null;
}

export interface EnterpriseNoticesV1RemoveEnterpriseNoticeForOrganizationMutation {
  EnterpriseNoticesV1: {
    removeEnterpriseNoticeForOrganization: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1RemoveEnterpriseNoticeForOrganizationMutationVariables {
  organizationId: string;
  includes?: string | null;
}

export interface EnterpriseNoticesV1UpdateMutation {
  EnterpriseNoticesV1: {
    update: EnterpriseNoticesV1Connection | null;
  } | null;
}

export interface EnterpriseNoticesV1UpdateMutationVariables {
  id: string;
  input: EnterpriseNotice;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseNoticesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseNotices.v1' as const;

  declare id: string;

  declare wrapped: string;

  declare enterpriseNotices: Record<string, NoticeData>;

  declare thirdPartyOrganizationId: string;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseNoticesV1>) {
    super(params);
  }
}
